import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { DeleteInitiativesUnlinkJiraRequest } from '@api';
import { InitiativeJiraIssuesName } from '../name';
import { getInitiativesJiraIssueSlice } from '../@async/get';

export const initiativesJiraIssueRemoveSyncSlice = createRemoveSyncSlice({
	name: InitiativeJiraIssuesName,
	state: getInitiativesJiraIssueSlice.asyncState,
	transform: (action: DeleteInitiativesUnlinkJiraRequest, state = []) => 
		state.filter((issue) => issue.issueKey !== action.issueKey)
});
